module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture23-50ee7b3ebfb8ed5003afe31b38da85a7.jpg";